import { computed, Injectable, Signal } from '@angular/core';
import { ServiceBasicInfoGridItemObject } from '@it2go/types';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';

@Injectable()
export class ServicePaymentFormStore extends ComponentStoreV2Factory {

    serviceBasicInfo: Signal<ServiceBasicInfoGridItemObject | null> = computed(() => this.data.getServiceBasicInfos()?.items?.[0] || null);

}
